import { useNavigate } from 'react-router-dom';
import { toast } from '@components';
import { TTransportShipment } from '@types';

type TShipmentNavInfo = Pick<TTransportShipment, 'id'>;

export const useTransportShipmentNavigation = () => {
	const navigate = useNavigate();

	const goToShipment = (shipment: TShipmentNavInfo, newTab = false) => {
		const id = shipment?.id;
		if (id) {
			const path = `/transport/all-loads/${id}`;
			if (newTab) {
				window.open(`${window.location.origin}${path}`, '_blank');
			} else {
				navigate(path);
			}
		} else {
			toast.info(`Sorry, we couldn't open this shipment.`);
		}
	};

	return { goToShipment };
};
